import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", { class: "title mb-2" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-file fa-w-12 mr-1" }),
  /*#__PURE__*/_createTextVNode(" Payment Success ")
], -1)
const _hoisted_5 = {
  key: 1,
  class: "card"
}
const _hoisted_6 = { class: "empty-channel py-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "icon-wrapper text-center" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-check" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createVNode("h5", null, "No invitations yet"),
  /*#__PURE__*/_createVNode("p", null, "Your payment was successfull!")
], -1)
const _hoisted_9 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.state.ui.isLoading.getInvoiceCompletedById)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_ErrorList, {
        errors: _ctx.state.ui.error.errorList.getInvoiceCompletedById,
        hasError: _ctx.state.ui.error.hasError
      }, null, 8, ["errors", "hasError"])
    ]),
    (_ctx.state.data.invoiceDetails && _ctx.state.data.invoiceDetails.uuid && _ctx.state.data.invoiceDetails.invoice_no)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createVNode("div", _hoisted_9, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn outline",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToReceivedInvoice && _ctx.redirectToReceivedInvoice(...args)))
              }, " Redirect to Invoice")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}